// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { PollMode, PollModeT } from "./poll-mode";
import { SubscribeMode, SubscribeModeT } from "./subscribe-mode";

/**
 * How a single monitored node is observed.
 */
export enum MonitorMode {
  NONE = 0,
  SubscribeMode = 1,
  PollMode = 2,
}

export function unionToMonitorMode(
  type: MonitorMode,
  accessor: (obj: PollMode | SubscribeMode) => PollMode | SubscribeMode | null,
): PollMode | SubscribeMode | null {
  switch (MonitorMode[type]) {
    case "NONE":
      return null;
    case "SubscribeMode":
      return accessor(new SubscribeMode())! as SubscribeMode;
    case "PollMode":
      return accessor(new PollMode())! as PollMode;
    default:
      return null;
  }
}

export function unionListToMonitorMode(
  type: MonitorMode,
  accessor: (index: number, obj: PollMode | SubscribeMode) => PollMode | SubscribeMode | null,
  index: number,
): PollMode | SubscribeMode | null {
  switch (MonitorMode[type]) {
    case "NONE":
      return null;
    case "SubscribeMode":
      return accessor(index, new SubscribeMode())! as SubscribeMode;
    case "PollMode":
      return accessor(index, new PollMode())! as PollMode;
    default:
      return null;
  }
}

export type MonitorModeT =
  | { type: "NONE"; value: null }
  | { type: "SubscribeMode"; value: SubscribeModeT }
  | { type: "PollMode"; value: PollModeT };
